import { useFormSchema } from "src/api/hooks/useFormSchema";

export const IntegerWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const { data: schema } = useFormSchema();
  const { minimum, maximum } = schema?.schema || {};
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`integer-container container`}>
      <input
        type="number"
        step="1"
        className={`input-integer`}
        value={value ?? ""}
        onChange={(e) => {
          const val =
            e.target.value === "" ? undefined : parseInt(e.target.value, 10);
          onChange(val);
        }}
        min={minimum}
        max={maximum}
        required={required}
      />
    </div>
  );
};
